import apiClient from './apiService';

// Service for the GRC admin dashboard widgets (AdminDashboard.tsx).
// Each call hits a small read-only aggregate endpoint scoped to the caller's
// entity via the JWT. Distinct from the per-module CRUD services.

export interface OrgKpis {
  departments: number;
  people: number;
  sops: number;
}

export interface RiskSummary {
  high: number;
  medium: number;
  low: number;
  scored: number;
  total_risks: number;
}

export interface ControlHealth {
  high: number;
  medium: number;
  low: number;
  scored: number;
  total_controls: number;
  healthy_pct: number;
}

export interface ComplianceSummary {
  total_obligations: number;
  upcoming: number;
  overdue: number;
  completed: number;
  litigations_pending: number;
  litigations_total: number;
}

export interface GovernanceSummary {
  tasks_upcoming: number;
  tasks_overdue: number;
  tasks_total: number;
  meetings_upcoming: number;
  meetings_overdue: number;
  meetings_total: number;
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

export const dashboardService = {
  async orgKpis(): Promise<OrgKpis> {
    const res = await apiClient.get<Envelope<OrgKpis>>('/api/v1/org/dashboard/org-kpis');
    return res.data.data;
  },

  async riskSummary(): Promise<RiskSummary> {
    const res = await apiClient.get<Envelope<RiskSummary>>('/api/v1/rsk/dashboard/risk-summary');
    return res.data.data;
  },

  async controlHealth(): Promise<ControlHealth> {
    const res = await apiClient.get<Envelope<ControlHealth>>('/api/v1/ctr/dashboard/control-health');
    return res.data.data;
  },

  async complianceSummary(): Promise<ComplianceSummary> {
    const res = await apiClient.get<Envelope<ComplianceSummary>>('/api/v1/com/dashboard/compliance-summary');
    return res.data.data;
  },

  async governanceSummary(): Promise<GovernanceSummary> {
    const res = await apiClient.get<Envelope<GovernanceSummary>>('/api/v1/gov/dashboard/governance-summary');
    return res.data.data;
  },
};

export default dashboardService;
